import { getBaseAppProtocolHost, BASE_APP_PROTOCOL_HOST } from './utils'
import { merge } from 'lodash'
import cookies from 'js-cookie'

// 基于环境的配置信息
export const CONFIG_ENV_APP_INFO_DICT = {
  // 本地环境
  'http://localhost:8000': {
    // 主应用 host
    base: {
      protocolHost: 'http://localhost:8000',
      homeUrl: 'http://localhost:8000/s/erp/#/',
    },
    // 子应用1
    bi: {
      entry: 'http://localhost:9000',
      syncMenuDomain: 'kjbidev.wdterp.com',
      baseAppUrlPrefix: 'http://localhost:8000/s/bi/#'
    },
    // 子应用2
    erp: {
      entry: 'http://localhost:9001',
      syncMenuDomain: 'kjjavadev.wdterp.com',
      baseAppUrlPrefix: 'http://localhost:8000/s/erp/#'
    },
  },
  'http://192.168.0.100:8000': {
    // 主应用 host
    base: {
      protocolHost: 'http://192.168.0.100:8000',
      homeUrl: 'http://192.168.0.100:8000/s/erp/#/',
    },
    // 子应用1
    bi: {
      entry: 'http://192.168.0.100:9000',
      syncMenuDomain: 'kjbidev.wdterp.com',
      baseAppUrlPrefix: 'http://192.168.0.100:8000/s/bi/#'
    },
    // 子应用2
    erp: {
      entry: 'http://192.168.0.100:9001',
      syncMenuDomain: 'kjjavadev.wdterp.com',
      baseAppUrlPrefix: 'http://192.168.0.100:8000/s/erp/#'
    },
  },
  // kj.yangli.com === localhost 本地  dns rebinding
  'http://kj.yangli.com:8000': {
    // 主应用 host
    base: {
      protocolHost: 'http://kj.yangli.com:8000',
      homeUrl: 'http://kj.yangli.com:8000/s/erp/#/',
    },
    // 子应用1
    bi: {
      entry: 'http://bi.yangli.com:9000',
      syncMenuDomain: 'bi.qizhishangke.com',
      baseAppUrlPrefix: 'http://kj.yangli.com:8000/s/bi/#'
    },
    // 子应用2
    erp: {
      entry: 'http://erp.yangli.com:9001',
      syncMenuDomain: 'erp.qizhishangke.com',
      baseAppUrlPrefix: 'http://kj.yangli.com:8000/s/erp/#'
    },
  },
  'https://kjdev-portal.wdterp.com': {
    // 塔外dev
    base: {
      protocolHost: 'https://kjdev-portal.wdterp.com/',
      homeUrl: 'https://kjdev-portal.wdterp.com/s/erp/#/',
    },
    bi: {
      // entry: 'https://szdev.huice.com',
      entry: 'https://kjbidev.wdterp.com',
      syncMenuDomain: 'kjbidev.wdterp.com',
      baseAppUrlPrefix: 'https://kjdev-portal.wdterp.com/s/bi/#'
    },
    erp: {
      entry: 'https://kjjavadev.wdterp.com',
      syncMenuDomain: 'kjjavadev.wdterp.com',
      baseAppUrlPrefix: 'https://kjdev-portal.wdterp.com/s/erp/#'
    },
  },
  // 老环境生产
  'https://kj.wangdian.cn': {
    base: {
      protocolHost: 'https://kj.wangdian.cn',
      homeUrl: 'https://kj.wangdian.cn/s/erp/#/',
    },
    bi: {
      entry: 'https://coss.wangdian.cn',
      syncMenuDomain: 'coss.wangdian.cn',
      baseAppUrlPrefix: 'https://kj.wangdian.cn/s/bi/#',
    },
    erp: {
      entry: 'https://cross.wangdian.cn',
      syncMenuDomain: 'cross.wangdian.cn',
      baseAppUrlPrefix: 'https://kj.wangdian.cn/s/erp/#',
    },
  },
  // qzsk 生产
  'https://kj.qizhishangke.com': {
    base: {
      protocolHost: 'https://kj.qizhishangke.com',
      homeUrl: 'https://kj.qizhishangke.com/s/erp/#/',
    },
    bi: {
      entry: 'https://bi.qizhishangke.com',
      syncMenuDomain: 'bi.qizhishangke.com',
      baseAppUrlPrefix: 'https://kj.qizhishangke.com/s/bi/#'
    },
    erp: {
      entry: 'https://erp.qizhishangke.com',
      syncMenuDomain: 'erp.qizhishangke.com',
      baseAppUrlPrefix: 'https://kj.qizhishangke.com/s/erp/#'
    },
  },
  'https://demo.qizhishangke.com': {
    base: {
      protocolHost: 'https://demo.qizhishangke.com',
      homeUrl: 'https://demo.qizhishangke.com/s/erp/#/',
    },
    bi: {
      entry: 'https://bi.qizhishangke.com',
      syncMenuDomain: 'bi.qizhishangke.com',
      baseAppUrlPrefix: 'https://demo.qizhishangke.com/s/bi/#'
    },
    erp: {
      entry: 'https://erp.qizhishangke.com',
      syncMenuDomain: 'erp.qizhishangke.com',
      baseAppUrlPrefix: 'https://demo.qizhishangke.com/s/erp/#'
    },
  },
}

// 基于子应用的配置信息
const CONFIG_APP_INFO_DICT = {
  // bi: {
  //   baseAppUrlPrefix: `${xxx}/s/bi/#`
  // },
  // erp: {
  //   baseAppUrlPrefix: `${xxx}/s/erp/#`
  // },
}

/**
 *
 * @returns 当前环境的 app 配置信息
 */
const getCurEnvConfigAppInfoDict = () => {
  const key = getBaseAppProtocolHost()
  console.log(key, '测试key')
  const middle = CONFIG_ENV_APP_INFO_DICT[key]
  return merge(CONFIG_APP_INFO_DICT, middle)
}
export const curEnvConfigAppInfoDict = getCurEnvConfigAppInfoDict()

/**
 *
 * @returns 菜单 url 转换的 pat
 */
function getMenuUrlReplacePat() {
  const replacePat = []
  Object.values(CONFIG_ENV_APP_INFO_DICT).forEach(appInfo => {
    const { base, ...subAppInfo } = appInfo
    Object.entries(subAppInfo).forEach(([subAppKey, subAppInfoDetail]) => {
      replacePat.push({
        pat: subAppInfoDetail.entry,
        replacement: curEnvConfigAppInfoDict[subAppKey].baseAppUrlPrefix,
      })
    })
  })

  return replacePat
}
export const menuUrlReplacePat = getMenuUrlReplacePat()

// 方便调试
window.__base_app_config__ = {
  curEnvConfigAppInfoDict,
  menuUrlReplacePat,
  cookies: cookies,
}
